import { createContent, DayOfWeek, ordinalIndicator } from '@altify/utils';
import { getWeekdayName } from 'app/_authenticated/trade/recurring-buy/helpers/weekdays';
import { RecurringBuyInterval } from 'app/_authenticated/trade/recurring-buy/models/RecurringBuyInterval';
import { formatDateString } from 'utils/date';

export const content = createContent({
  en: {
    cancelRecurringBuy: 'Cancel Recurring Buy',
    resumeRecurringBuy: 'Resume Recurring Buy',
    pauseRecurringBuy: 'Pause Recurring Buy',
    nextExecutionDate(nextExecution: Date) {
      return formatDateString(nextExecution, 'en');
    },
    panels: (
      paused: boolean,
      amount: string,
      interval: RecurringBuyInterval | undefined,
      firstBuy: Date | undefined,
      nextBuy: Date,
      streak: number,
      dayOfWeek: DayOfWeek | undefined,
      dayOfMonth: number | null | undefined,
    ) => [
        {
          id: 1,
          subtitle: 'Status',
          title: paused ? 'Paused' : 'Active',
        },
        {
          id: 2,
          subtitle: 'Amount',
          title: amount,
        },
        {
          id: 3,
          subtitle: 'Frequency',
          title:
            interval == 'weekly'
              ? `Weekly on ${getWeekdayName(dayOfWeek!, 'en')}s`
              : `Monthly on the ${dayOfMonth}${ordinalIndicator(
                dayOfMonth ?? 0,
              )}`,
        },
        {
          id: 4,
          subtitle: 'Created At',
          title:
            firstBuy?.toLocaleString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            }) ?? '-',
        },
        {
          id: 5,
          subtitle: 'Next Buy',
          title: nextBuy.toLocaleString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          }),
        },
        {
          id: 6,
          subtitle: 'Buy Streak',
          title: `${streak} Buy${streak != 1 ? 's' : ''}`,
        },
      ],
  },
  de: {
    cancelRecurringBuy: 'Cancel Recurring Buy',
    resumeRecurringBuy: 'Resume Recurring Buy',
    pauseRecurringBuy: 'Pause Recurring Buy',
    nextExecutionDate(nextExecution: Date) {
      return formatDateString(nextExecution, 'de');
    },
    panels: (
      paused: boolean,
      amount: string,
      frequency: RecurringBuyInterval | undefined,
      firstBuy: Date | undefined,
      nextBuy: Date,
      streak: number,
      dayOfWeek?: DayOfWeek | null,
      dayOfMonth?: number | null | undefined,
    ) => [
        {
          id: 1,
          subtitle: 'Status',
          title: paused ? 'Pausiert' : 'Aktiv',
        },
        {
          id: 2,
          subtitle: 'Betrag',
          title: amount,
        },
        {
          id: 3,
          subtitle: 'Frequenz',
          title:
            frequency == 'weekly'
              ? `Wöchentlich am ${getWeekdayName(dayOfWeek!, 'de')}`
              : `Monatlich am ${dayOfMonth}.`,
        },
        {
          id: 4,
          subtitle: 'Erstellt Am',
          title:
            firstBuy?.toLocaleString('de', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            }) ?? '-',
        },
        {
          id: 5,
          subtitle: 'Nächster Kauf',
          title: nextBuy.toLocaleString('de', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          }),
        },
        {
          id: 6,
          subtitle: 'Buy Streak',
          title: `${streak} ${streak != 1 ? 'Käufe' : 'Kauf'}`,
        },
      ],
  },
});
